import { render, staticRenderFns } from "./BarChartJs.htm?vue&type=template&id=c6fee5a2&scoped=true&"
import script from "./BarChartJs.ts?vue&type=script&lang=js&"
export * from "./BarChartJs.ts?vue&type=script&lang=js&"
import style0 from "./BarChartJs.scss?vue&type=style&index=0&id=c6fee5a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fee5a2",
  null
  
)

export default component.exports